<script>
import Layout from '@layouts/main'

export default {
  metaInfo: {
    title: 'Reports',
    meta: [{ name: 'description', content: 'Reports' }],
  },
  components: { Layout },
  data() {
    return {
      // TODO: Replace with real queries
      queryItems: ['Query A', 'Query B', 'Query C'],

      // TODO: Replace with real data
      dummyHeaders: [
        { text: 'Report', value: 'report' },
        { text: 'Description', value: 'description' },
      ],
      dummyItems: [
        {
          report: 'Clinical Laboratory Fee Schedule (CMS)',
          description: 'Lab payment rates, by state',
        },
        {
          report: 'CPT and HCPCS Currently Valid',
          description: 'Lab payment rates, by state',
        },
        {
          report: 'DME and PEN Fee Schedules from CMS',
          description: 'Lab payment rates, by state',
        },
        {
          report: 'HCPCS to Revenue Code Crosswalk',
          description: 'Lab payment rates, by state',
        },
        {
          report: 'Medicare Physician Fee Schedule',
          description: 'Lab payment rates, by state',
        },
        {
          report: 'Modifier Crrosswalk by HCPCS',
          description: 'Lab payment rates, by state',
        },
      ],
    }
  },
}
</script>

<template>
  <Layout>
    <v-container fluid grid-list-md ma-0>
      <!-- Header -->
      <v-layout row>
        <v-flex xs5 align-self-center>
          <h3>Reports</h3>
        </v-flex>

        <v-flex xs2>
          <v-select
            :items="queryItems"
            label="Choose query"
            color="cyan"
          ></v-select>
        </v-flex>

        <v-flex xs4 class="ml-4">
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            color="cyan"
            single-line
            hide-details
          ></v-text-field>
        </v-flex>

        <v-flex xs2 class="text-xs-right">
          <v-btn dark depressed color="cyan">Add Query</v-btn>
        </v-flex>
      </v-layout>

      <v-card>
        <v-data-table
          :headers="dummyHeaders"
          :items="dummyItems"
          :loading="loading"
          hide-actions
        >
          <template slot="items" slot-scope="props">
            <td>{{ props.item.report }}</td>
            <td>{{ props.item.description }}</td>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </Layout>
</template>
